import { IconLetter } from '@smartbear/swagger-portal-component-library'

import { ApiSubNavItem } from '../ApiSubNavItem'
import { AsyncApiMessage } from '~/portal/types/content'

export const ApiSubNavMessage = ({
  parentPath,
  message,
  active = false,
  isSelected,
  setSelectedMessage,
  onClick,
}: {
  parentPath: string,
  message: AsyncApiMessage,
  active?: boolean,
  isSelected: boolean,
  setSelectedMessage: (selectedMessage: string | null) => void,
  onClick?: (e) => void,
}) => {
  const messageIdentifier = message.messageId
  const messageHash = `#/default/message-${encodeURIComponent(messageIdentifier)}`

  return (
    <ApiSubNavItem
      parentPath={parentPath}
      identifier={messageIdentifier}
      hash={messageHash}
      icon={<IconLetter width={12} height={12} />}
      active={active}
      isSelected={isSelected}
      setSelectedItem={setSelectedMessage}
      onClick={onClick}
    />
  )
}